module.exports = __webpack_public_path__ + "img/szjc4.a7a3338b.png";